import React from 'react'
import { Helmet } from 'react-helmet'
import { useStyles } from '../Lost_style'
import { Box } from '@material-ui/core'
import Oops from '../components/Oops/Oops'
import LostRecommendedArticles from '../components/LostRecommendedArticles/LostRecommendedArticles'

const LostArticlePage = (props) => {
    const { user } = props
    const classes = useStyles()

    return (<>
        <Helmet>
            <meta name='robots' content='noindex' />
            <meta name='googlebot' content='noindex' />
        </Helmet>
        <Oops subtitleId='item_show.does_not_exist.article' />
        <Box className={classes.similarArticlesBox}>
            <LostRecommendedArticles user={user} moreItemsId='lost.recommended_articles.more_items'/>
        </Box>
    </>)
}

export default LostArticlePage 